import React from 'react';
import { FetchOptionsResult, Select, SelectOption } from '../Select';

interface MultiInputProps {
  options?: SelectOption[];
  value: string[];
  onChange: (value: string[]) => void;
  name?: string;
  placeholder?: string;
  icon?: React.ReactNode;
  disabled?: boolean;
  className?: string;
  triggerStyle?: React.CSSProperties;
  searchable?: boolean;
  fetchOptions?: (params: { page: number; search: string }) => Promise<FetchOptionsResult>;
  renderOption?: (option: SelectOption, state: { selected: boolean }) => React.ReactNode;
  renderValue?: (option: SelectOption | null) => React.ReactNode;
  searchPlaceholder?: string;
}

const MultiInput: React.FC<MultiInputProps> = props => (
  <Select
    mode="multi"
    {...props}
  />
);

export { MultiInput };
export type { MultiInputProps };
